import { Button, Stack, Typography } from "@mui/material";
import usePacks from "../utils/usePacks";
import "../../../css/product.css";
import { Link } from "react-router-dom";

export default function Packs(){

    const { isSuccess, data } = usePacks()
    
    return (isSuccess && data.length > 0) &&

        <Stack spacing={1}>

            <Typography variant="h1">Packs de formations</Typography>

            <Stack direction="row" flexWrap="wrap">

            {data.map(p => 

                <article key={p.id} className="product">

                    <div 
                        className="product-img" 
                        style={{backgroundImage: `url(${p.picture.url})`}}
                    >
                    </div>

                    <div className="product-content">
                        <span>
                            {p.title}
                        </span>
                    </div>

                    <Button 
                        sx={{width: '100%', height: 50}}
                        color="info"
                        component={Link}
                        to={`/packs/${p.reference}`}
                    >
                        S'inscrire
                    </Button>

                </article>    
            )}

            </Stack>


        </Stack>
}